import React from 'react';
import './TarhDar.css';
import config from './../../../services/config.json';
import SimpleContext from './../../context/SimpleContext';
import { useContext } from 'react';
import Img from 'react-image';

const TarhDarProduct = ({images, title, description, Percent, Az, Ta}) => {

    const context = useContext(SimpleContext);
    let styleee = context.style
    if (context.SumTarh>=Az && context.SumTarh<=Ta) {
        styleee = "TarhNamePlaceSelected"
    }

    return (
        <>
            
            <div className="imagePlace" >

                <img src={`${config.DiscountImage}/${images}`} alt="tarh" className="tarhImg"/>
                {/* <Img src={[`${config.DiscountImage}/${images}` , "./images/placeholder.jpg"]} alt="tarh" className="tarhImg"/> */}
                <p className="Percent">%{(Percent)/1}<br/>تخفیف</p>

            </div>

            <div className={styleee}>
                
                <p>{description}</p>
                <hr className="hr"/>
                <p>
                {
                    title.split('*').map((item, key) => {
                    return <p key={key}>{item}</p>
                    })
                }
                </p>
                
            </div>

        </> 
    );
}
 
export default TarhDarProduct;